import { createResource } from '@atlassian/react-resource-router';
import type { WorkTypeReportsData } from './types.tsx';

const RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS = 'WORK_TYPE_PROJECTS_LIMITS';

export const workTypeProjectsLimitsResource = createResource<WorkTypeReportsData>({
	type: RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS,
	getKey: () => 'workTypeProjectsLimits',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-work-type-projects-limits", jiraSpaEntry: "async-resource-work-type-projects-limits" */ './get-data/index.tsx'
		),
});
